// extracted by mini-css-extract-plugin
module.exports = {"root":"link-with-arrow_root__wgXMg"};